@if (isLoading()) {
  <div
    class="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-999999999"
  >
    <hlm-spinner />
  </div>
}
